import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { $tk } from 'utils/appTranslationKey';

import { AddPromotionDurationFC, AddPromotionDurationFCProps } from './AddPromotionDurationFC';

const useStrings = (): AddPromotionDurationFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      title: intl.formatMessage({ id: $tk.components.AddPromotionDuration.title }),
      description: intl.formatMessage({ id: $tk.components.AddPromotionDuration.description }),
      continue: intl.formatMessage({ id: $tk.buttons.continue }),
      back: intl.formatMessage({ id: $tk.buttons.back }),
    }),
    [intl],
  );
};

type AddPromotionDurationProps = Omit<AddPromotionDurationFCProps, 'strings'>;

export function AddPromotionDuration(props: AddPromotionDurationProps) {
  const strings = useStrings();
  return <AddPromotionDurationFC {...props} strings={strings} />;
}
